import { UpdateInvestmentJurisdictionRequest } from '../../../../web-api-client';
import { InvestmentJurisdiction } from '../../models';

export const mapInvestmentJurisdictionToUpdateRequest = (
  investmentJurisdiction: InvestmentJurisdiction
): UpdateInvestmentJurisdictionRequest => {
  return new UpdateInvestmentJurisdictionRequest({
    investmentJurisdictionId: investmentJurisdiction.investmentJurisdictionId,
    countryId: investmentJurisdiction.country!.countryId!,
    isActive: investmentJurisdiction.isActive,
    isDisplay: investmentJurisdiction.isDisplay,
  });
};
